import { User } from '../../gql/graphql';

interface UsersState {
  user?: User;
}

export const initialState = {
  user: undefined,
} as UsersState;
